import {
  getResourceScheduleDurationSlotsFromDates,
  getResourceScheduleSlotIndexForDate,
} from './resourceScheduleSlotMath';

export interface ResourceScheduleResizePreview {
  startSlotIndex: number;
  durationSlots: number;
}

interface CreateResourceScheduleResizePreviewOptions {
  originalStart: Date;
  originalEnd: Date;
  timelineStart: Date;
  intervalMinutes: number;
}

interface ResolveResourceScheduleResizePreviewUpdateOptions extends CreateResourceScheduleResizePreviewOptions {
  edge: 'left' | 'right';
  slotsDelta: number;
  maxTimelineSlots: number;
}

export function createResourceScheduleResizePreview({
  originalStart,
  originalEnd,
  timelineStart,
  intervalMinutes,
}: CreateResourceScheduleResizePreviewOptions): ResourceScheduleResizePreview {
  return {
    startSlotIndex: getResourceScheduleSlotIndexForDate(
      originalStart,
      timelineStart,
      intervalMinutes,
      'round',
    ),
    durationSlots: getResourceScheduleDurationSlotsFromDates(
      originalStart,
      originalEnd,
      intervalMinutes,
      'round',
    ),
  };
}

export function resolveResourceScheduleResizePreviewUpdate({
  originalStart,
  originalEnd,
  timelineStart,
  intervalMinutes,
  edge,
  slotsDelta,
  maxTimelineSlots,
}: ResolveResourceScheduleResizePreviewUpdateOptions): ResourceScheduleResizePreview | null {
  const originalStartSlot = getResourceScheduleSlotIndexForDate(
    originalStart,
    timelineStart,
    intervalMinutes,
    'round',
  );
  const originalEndSlot = getResourceScheduleSlotIndexForDate(
    originalEnd,
    timelineStart,
    intervalMinutes,
    'round',
  );
  const originalDurationSlots = originalEndSlot - originalStartSlot;

  if (edge === 'right') {
    const newDuration = Math.max(1, originalDurationSlots + slotsDelta);
    const clampedDuration = Math.min(newDuration, maxTimelineSlots - originalStartSlot);

    return {
      startSlotIndex: originalStartSlot,
      durationSlots: clampedDuration,
    };
  }

  const newStartSlot = Math.max(0, originalStartSlot + slotsDelta);
  const newDuration = originalEndSlot - newStartSlot;

  if (newDuration < 1) {
    return null;
  }

  return {
    startSlotIndex: newStartSlot,
    durationSlots: newDuration,
  };
}